"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require(".");
var _util = require("../../util");
var Card = function Card(_ref) {
  var productType = _ref.productType,
    constants = _ref.constants,
    offers = _ref.offers,
    register = _ref.register;
  var _getFields = getFields(productType, constants),
    title = _getFields.title,
    index = _getFields.index,
    monthlyIndex = _getFields.monthlyIndex,
    subheader1 = _getFields.subheader1,
    subheader2 = _getFields.subheader2;
  var bem = (0, _util.bemClass)('revision-offers');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: bem('card')
  }, /*#__PURE__*/_react.default.createElement(_.CardHeader, {
    title: title,
    index: index,
    subheader1: subheader1,
    subheader2: subheader2
  }), offers.sort(function (x, y) {
    return y.productTerm - x.productTerm;
  }).map(function (o) {
    return o.isValid && o.isValidForClient ? /*#__PURE__*/_react.default.createElement(_.ValidOffer, Object.assign({
      key: o.id,
      monthlyIndex: monthlyIndex,
      register: register
    }, o)) : /*#__PURE__*/_react.default.createElement(_.InvalidOffer, Object.assign({
      key: o.id
    }, o));
  }));
};
Card.propTypes = {
  productType: _propTypes.default.string.isRequired,
  constants: _propTypes.default.shape().isRequired,
  offers: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  register: _propTypes.default.func.isRequired
};
function getFields(productType, constants) {
  var _constants$INTEREST_F, _constants$PROMOTIONA, _constants$INSTALLMEN, _constants$LC_FIXED_R, _constants$LC_TRUE_NO;
  switch (productType) {
    case _util.PRODUCT_TYPE_ABBR.INTEREST_FREE_LOAN:
      return {
        title: (_constants$INTEREST_F = constants.INTEREST_FREE_LOAN) === null || _constants$INTEREST_F === void 0 ? void 0 : _constants$INTEREST_F.pluralName,
        index: _util.DISCLOSURES.IF.index,
        monthlyIndex: _util.DISCLOSURES.IF.monthlyIndex,
        subheader1: 'No Interest for 6 or 12 mo',
        subheader2: 'after that, 26.99% standard APR'
      };
    case _util.PRODUCT_TYPE_ABBR.PROMOTIONAL_RATE_PLAN:
      return {
        title: (_constants$PROMOTIONA = constants.PROMOTIONAL_RATE_PLAN) === null || _constants$PROMOTIONA === void 0 ? void 0 : _constants$PROMOTIONA.pluralName,
        index: _util.DISCLOSURES.PRP.index,
        monthlyIndex: _util.DISCLOSURES.PRP.monthlyIndex,
        subheader1: '17.90% APR for 24, 36, 48 or 60 mo',
        subheader2: 'after that, 26.99% standard APR'
      };
    case _util.PRODUCT_TYPE_ABBR.INSTALLMENT_LOAN:
      return {
        title: (_constants$INSTALLMEN = constants.INSTALLMENT_LOAN) === null || _constants$INSTALLMEN === void 0 ? void 0 : _constants$INSTALLMEN.pluralName,
        monthlyIndex: _util.DISCLOSURES.IL.monthlyIndex,
        subheader1: 'Payment amount and interest rate will stay',
        subheader2: 'the same as the loan is paid off'
      };
    case _util.PRODUCT_TYPE_ABBR.LC_FIXED_RATE_PLAN:
      return {
        title: (_constants$LC_FIXED_R = constants.LC_FIXED_RATE_PLAN) === null || _constants$LC_FIXED_R === void 0 ? void 0 : _constants$LC_FIXED_R.displayName,
        index: _util.DISCLOSURES.LC.index,
        subheader1: 'Rate based on amount financed and credit history.',
        subheader2: 'Payment amount stays the same as loan is paid off.'
      };
    case _util.PRODUCT_TYPE_ABBR.LC_TRUE_NO_INTEREST:
      return {
        title: (_constants$LC_TRUE_NO = constants.LC_TRUE_NO_INTEREST) === null || _constants$LC_TRUE_NO === void 0 ? void 0 : _constants$LC_TRUE_NO.displayName,
        index: _util.DISCLOSURES.LC.index,
        subheader1: 'Pay no interest for up to 36 months',
        subheader2: ''
      };
    default:
      return {
        title: '',
        subheader1: '',
        subheader2: ''
      };
  }
}
var _default = Card;
exports.default = _default;
